import { render, staticRenderFns } from "./scene-object.vue?vue&type=template&id=a80c00a0&scoped=true&"
import script from "./scene-object.vue?vue&type=script&lang=js&"
export * from "./scene-object.vue?vue&type=script&lang=js&"
import style0 from "./scene-object.vue?vue&type=style&index=0&id=a80c00a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80c00a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a80c00a0')) {
      api.createRecord('a80c00a0', component.options)
    } else {
      api.reload('a80c00a0', component.options)
    }
    module.hot.accept("./scene-object.vue?vue&type=template&id=a80c00a0&scoped=true&", function () {
      api.rerender('a80c00a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scene-object.vue"
export default component.exports